import { useRef } from "react";
import mojs from "@mojs/core";
import clap from "../../assets/images/clap.svg";
import clapBlue from "../../assets/images/clap-blue.svg";

export const ClapButton = ({onClapClick, feedId, userClapCount}) => {
  const clapButton = useRef(null);
  const clapCountSpan = useRef(null);
  const onClap = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();

    const clap = clapButton.current;
    const clapCount = clapCountSpan.current;
    const tlDuration = 300;
    const triangleBurst = new mojs.Burst({
      parent: clap,
      radius: { 50: 95 },
      count: 5,
      angle: 30,
      children: {
        shape: "polygon",
        radius: { 6: 0 },
        scale: 1,
        stroke: "rgba(211,84,0 ,0.5)",
        strokeWidth: 2,
        angle: 210,
        delay: 30,
        speed: 0.2,
        easing: mojs.easing.bezier(0.1, 1, 0.3, 1),
        duration: 300,
      },
      onComplete: function() {
        this.el.parentNode.removeChild(this.el);
      }
    });
    const circleBurst = new mojs.Burst({
      parent: clap,
      radius: { 50: 75 },
      angle: 25,
      duration: tlDuration,
      children: {
        shape: "circle",
        fill: "rgba(149,165,166 ,0.5)",
        delay: 30,
        speed: 0.2,
        radius: { 3: 0 },
        easing: mojs.easing.bezier(0.1, 1, 0.3, 1),
      },
      onComplete: function() {
        this.el.parentNode.removeChild(this.el);
      }
    });
    const countAnimation = new mojs.Html({
      el: clapCount,
      isShowStart: false,
      isShowEnd: true,
      y: { 0: -30 },
      opacity: { 0: 1 },
      duration: tlDuration,
    }).then({
      opacity: { 1: 0 },
      y: -80,
      delay: tlDuration / 2,
    });
    const scaleButton = new mojs.Html({
      el: clap,
      duration: tlDuration,
      scale: { 1.3: 1 },
      easing: mojs.easing.out,
    });
    clap.style.transform = "scale(1, 1)"; /*Bug1 fix*/

    const animationTimeline = new mojs.Timeline();
    animationTimeline.add([
      triangleBurst,
      circleBurst,
      countAnimation,
      // countTotalAnimation,
      scaleButton,
    ]);
    animationTimeline.replay();
    const count = userClapCount ? userClapCount + 1 : 1
    clapCount.innerHTML = `+${count}`;
    onClapClick(feedId)
  };
  return (
    <div
    className="w-14 border-solid border-gray-400 border h-14 flex justify-center items-center rounded-full absolute -inset-y-7 right-5 bg-white"
    onClick={onClap}
    ref={clapButton}
  >
    <img src={userClapCount ? clapBlue : clap} className="absolute" alt="clapIcon" />
    <span
      className="clap--count"
      ref={clapCountSpan}
    ></span>
  </div>
  )
}